import type { Router } from 'vue-router';
import { useAppPagePaths } from '../store';

/*
 * 路径中包含有 app:// 表示需要跨应用跳转:
 * 通过Vue白名单匹配目标路径的应用是否当前应用，同一应用-》run 2，不同应用-》run 1
 * 1.真实不同应用, 用location.href跳转
 * 2.历史迁移的写法,已经在同一个应用中, 用router.push跳转
 */
export function createAppRouterGuard(router: Router) {
  const appPagePaths = useAppPagePaths();
  router.beforeEach(async (to, from) => {
    const toFullPath = to.fullPath;
    const isCrossApp = toFullPath.includes('app://');
    const pathName = isCrossApp ? toFullPath.split('app://')[1] : toFullPath;

    // console.log({ to, isCrossApp, pathName });

    if (isCrossApp) {
      // 是否相同应用
      const isCurrentApp =
        import.meta.env.VITE_ROUTE_PATH_CHECK === 'on' ? appPagePaths.getIsCurrentApp(pathName) : false;
      console.log('isCurrentApp =>', isCurrentApp);
      if (!isCurrentApp) {
        const url = `${import.meta.env.VITE_SITE_HOST || location.origin}/${pathName}`;
        console.log('url: ', url);
        location.href = `${import.meta.env.VITE_SITE_HOST || location.origin}/${pathName}`;
        return false;
      } else {
        return { path: pathName.split('caizhi_webapp')[1], query: to.query, params: to.params, hash: to.hash };
      }
    }
  });
}
